import { render, staticRenderFns } from "./FinishDetail.vue?vue&type=template&id=5529a94b&scoped=true"
import script from "./FinishDetail.vue?vue&type=script&lang=ts"
export * from "./FinishDetail.vue?vue&type=script&lang=ts"
import style0 from "./FinishDetail.vue?vue&type=style&index=0&id=5529a94b&prod&lang=scss"
import style1 from "./FinishDetail.vue?vue&type=style&index=1&id=5529a94b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529a94b",
  null
  
)

export default component.exports